"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = `
query intake($subscriptionId: Int!) {
  intake(subscriptionId: $subscriptionId) {
    period {
      code {
        gender
      }
    }
    disc {
      name
      value: result
    }
    hormone {
      name
      value: result
    }
    bodyFeatures {
      name
      size
    }
    nutritionExperience
    trainingExperience
    extraQuestions {
      category
      question
      answer
      comment
    }
    xPlanQuestions {
      question
      answer
    }
  } 
}
`;
//# sourceMappingURL=intakeQuery.js.map